import { create, StateCreator } from 'zustand';
import { Unionize } from 'utilitys/helpers/TsGeneral';

interface Props {
    username: string | null;
    password: string | null;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}
const state: StateCreator<Props> = (set) => ({
    username: null,
    password: null,
    update: (value) => set({ ...value }),
});
export const useLoginStore = create(state);
